/*
 * Invisible bot checks for the public signup forms (Eric 2026-10-27). Server side: app/src/http/form-guard.ts.
 *
 *  - adds a hidden honeypot field (fax_number) that a person never sees or fills;
 *  - fetches a signed timestamp from the app when the page loads (GET /apps/dashboard/form-token);
 *  - CircadiaFormGuard.fields(form) resolves { form_token, fax_number } for the form's JSON body, and holds the submit
 *    back until the token is old enough for the server (a person who submits in the first moments waits for a blink,
 *    never sees an error).
 *
 * If anything here fails (no network, no token) fields() still resolves, with an empty token; the server then answers
 * with a plain "reload and try again". Nothing on the page is visible and nothing is asked of the visitor.
 */
(function () {
  'use strict';
  if (window.CircadiaFormGuard) return;

  var TOKEN_URL = '/apps/dashboard/form-token';
  var FORMS = '[data-newsletter-form], [data-launch-form], [data-stock-notify-form], [data-wholesale-form]';
  var MIN_AGE_MS = 3300; // the server refuses under 3000 ms; a little over, for timer drift
  var HONEYPOT = 'fax_number';

  var pending = null;
  var receivedAt = 0;

  function fetchToken() {
    if (pending) return pending;
    pending = fetch(TOKEN_URL, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { receivedAt = Date.now(); return (j && typeof j.token === 'string') ? j.token : ''; })
      .catch(function () { receivedAt = Date.now(); return ''; });
    return pending;
  }

  function attach(form) {
    if (!form || form.querySelector('[data-form-guard]')) return;
    var wrap = document.createElement('div');
    wrap.setAttribute('data-form-guard', '');
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.cssText = 'position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;';
    var input = document.createElement('input');
    input.type = 'text';
    input.name = HONEYPOT;
    input.tabIndex = -1;
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('data-form-guard-field', '');
    wrap.appendChild(input);
    form.appendChild(wrap);
  }

  function fields(form) {
    var trap = form && form.querySelector ? form.querySelector('[data-form-guard-field]') : null;
    // A token fetch that failed at page load (the app restarting, a blocked request) is tried once more now, so the submit still carries a token and is held like any other.
    return fetchToken().then(function (token) {
      if (token) return token;
      pending = null;
      return fetchToken();
    }).then(function (token) {
      var wait = token ? Math.max(0, MIN_AGE_MS - (Date.now() - receivedAt)) : 0;
      return new Promise(function (resolve) {
        setTimeout(function () {
          var out = { form_token: token };
          out[HONEYPOT] = trap ? trap.value : '';
          resolve(out);
        }, wait);
      });
    });
  }

  /** Merge the guard fields into a payload and hand it on: with(form, payload, function (payload) { ... }). */
  function withGuard(form, payload, next) {
    fields(form).then(function (g) {
      payload.form_token = g.form_token;
      payload[HONEYPOT] = g[HONEYPOT];
      next(payload);
    });
  }

  window.CircadiaFormGuard = { attach: attach, fields: fields, withGuard: withGuard };

  function init() {
    var forms = document.querySelectorAll(FORMS);
    if (!forms.length) return;
    for (var i = 0; i < forms.length; i++) attach(forms[i]);
    fetchToken();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
